angular.module('bb.appointments').factory('FeedbackService', FeedbackService);

FeedbackService.$inject = ['$resource'];
function FeedbackService($resource) {
  const FeedbackSettings = $resource('/listing/:listingId/feedback_settings', {
    listingId: '@listingId',
  });

  const FeedbackList = $resource('/listing/:listingId/feedbacks', {
    listingId: '@listingId',
  });

  const Feedback = $resource(
    'listing/:listingId/appointment/:appointmentId/feedback',
    {
      appointmentId: '@appointmentId',
      listingId: '@listingId',
    },
  );

  const FeedbackReminders = $resource(
    '/listing/:listingId/send_feedback_reminder/:appointmentId',
    { listingId: '@listingId', appointmentId: '@appointmentId' },
  );

  const FeedbackForCoop = $resource(
    '/user/coop/listing/:listingId/appointment/:appointmentId/feedback',
    {
      appointmentId: '@appointmentId',
      listingId: '@listingId',
    },
  );

  const EmailTemplates = $resource(
    '/listing/:listingId/template/list?type=feedback',
    {
      listingId: '@listingId',
    },
  );

  const EmailSignatures = $resource(
    '/listing/:listingId/template/rep_signature',
    {
      listingId: '@listingId',
    },
  );

  function getSettings(listingId) {
    return FeedbackSettings.get({ listingId }).$promise;
  }

  function saveSettings(listingId, settings) {
    delete settings.id;
    settings.listing =
      typeof settings.listing === 'string'
        ? settings.listing
        : settings.listing.id;
    return FeedbackSettings.save({ listingId }, settings).$promise;
  }

  function getFeedbackList(listingId) {
    return FeedbackList.get({ listingId }).$promise;
  }

  function getFeedback(appointmentId, listingId) {
    return Feedback.get({ appointmentId, listingId }).$promise;
  }

  function saveFeedback(appointmentId, listingId, feedback) {
    return Feedback.save({ appointmentId, listingId }, feedback).$promise;
  }

  function sendFeedbackReminder(listingId, appointmentId) {
    return FeedbackReminders.save({ listingId, appointmentId }).$promise;
  }

  function getFeedbackForCoop(appointmentId, listingId) {
    return FeedbackForCoop.get({ appointmentId, listingId }).$promise;
  }

  function saveFeedbackByCoop(appointmentId, listingId, feedback) {
    return FeedbackForCoop.save({ appointmentId, listingId, feedback })
      .$promise;
  }

  function getFeedbackTemplates(listingId) {
    return EmailTemplates.query({ listingId }).$promise;
  }

  function getRepsSignatures(listingId) {
    return EmailSignatures.get({ listingId }).$promise;
  }

  return {
    getSettings,
    saveSettings,
    getFeedbackList,
    getFeedback,
    saveFeedback,
    sendFeedbackReminder,
    getFeedbackForCoop,
    saveFeedbackByCoop,
    getFeedbackTemplates,
    getRepsSignatures,
  };
}

export {};
